import { QueryClient } from '@tanstack/react-query';
import { LIST_ITEMS_COUNT } from '@/constants/lists.constants';
import { txCenterProvidersQueries } from '@/queries/txcenter-providers';

export const txCenterProviderLoader = (queryClient: QueryClient) => () => {
  return queryClient.ensureQueryData(txCenterProvidersQueries.list({ itemsPerPage: LIST_ITEMS_COUNT, pageIndex: 0 }));
};

export const txCenterProviderByIdLoader = (queryClient: QueryClient) => (logisticProviderId: string) => {
  return queryClient.ensureQueryData({
    ...txCenterProvidersQueries.item(logisticProviderId),
    revalidateIfStale: true,
  });
};
